import { storeToRefs } from 'pinia'
import { useStore } from 'vuex'
import { computed } from 'vue'

import { isFeatureSupported } from '@app/adapters/silverfin'
import useCheckHelpers from '@app/application/communication/sections/communication/composables/use-check-helpers'
import {
  doneChecks,
  pendingChecks,
} from '@app/application/sf-assistant-checks/utils'

import { useCommsFilterStore } from '@app/application/communication/store/comms-filters'
import { useChecksStore } from '@app/application/sf-assistant-checks/stores/checks'

/**
 * Composable function to get the header item data for the communication sidebar header
 * TODO: Refactor to TS once the comms store is refactored to TS
 */
export default function useItemCounts() {
  const { checkCheckedByAllParticipants } = useCheckHelpers()

  const checksStore = useChecksStore()
  const commsStore = useStore()

  const supportsCommunicationsRework = isFeatureSupported(
    'supports_communications_rework'
  )

  const notes = computed(() => commsStore.getters.notes)
  const todos = computed(() => commsStore.getters.todos)
  const allChecks = computed(() => commsStore.getters.allChecks)
  const filteredSfAssistantRemarks = computed(
    () => commsStore.getters.filteredSfAssistantRemarks
  )
  const notificationsByRemarkId = computed(
    () => commsStore.getters.notificationsByRemarkId
  )

  const { checks } = storeToRefs(checksStore)

  const allNotesCount = computed(() => Object.keys(notes.value).length)
  const unreadNotesCount = computed(() => {
    if (!supportsCommunicationsRework) {
      return 0
    }

    return Object.values(notes.value).reduce((acc, note) => {
      const notification = notificationsByRemarkId.value[note.id]
      return notification && !notification.read ? acc + 1 : acc
    }, 0)
  })

  const allTodosCount = computed(
    () =>
      todosCount.value + doneSfAChecksCount.value + pendingSfAChecksCount.value
  )
  const todosCount = computed(() => Object.keys(todos.value).length)
  const doneSfAChecksCount = computed(
    () => doneChecks(checks.value, filteredSfAssistantRemarks.value).length
  )
  const pendingSfAChecksCount = computed(
    () => pendingChecks(checks.value, filteredSfAssistantRemarks.value).length
  )
  const pendingTodosCount = computed(
    () =>
      Object.values(todos.value).filter((todo) => !todo.done).length +
      pendingSfAChecksCount.value
  )

  const unreadTodosCount = computed(() => {
    if (!supportsCommunicationsRework) {
      return 0
    }

    return Object.values(todos.value).reduce((acc, todo) => {
      const notification = notificationsByRemarkId.value[todo.id]
      return notification && !notification.read ? acc + 1 : acc
    }, 0)
  })

  const allChecksCount = computed(() => Object.keys(allChecks.value).length)
  const pendingChecksCount = computed(
    () =>
      Object.values(allChecks.value).filter(
        (check) => !checkCheckedByAllParticipants(check)
      ).length
  )

  function handleItemClick(type) {
    const filterStore = useCommsFilterStore()

    filterStore.toggleTypeFilter(type)
    commsStore.dispatch('unsetHighlightedCard')
    window.eventHub.$emit('clearAnchor')
  }

  return {
    allChecksCount,
    allNotesCount,
    allTodosCount,
    handleItemClick,
    pendingChecksCount,
    pendingTodosCount,
    unreadNotesCount,
    unreadTodosCount,
  }
}
